import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { SingleResultGrid } from '../../../../../grid/SingleResultGrid';
import { Column } from '../../../../../grid/Column';
import { parseAndShortenFloat } from '../../../../../../helperFunctions/helperFunctions';
import { Loading } from '../../../../../loadbar/Loading';
import { isDataManager } from '../../../../../../role/roleUtils';

import {
  getDeposit as getDepositAc,
  getGeologicAges as getGeologicAgesAc,
  getPublications as getPublicationsAc,
  clearData as clearDataAc,
  deleteTsunami as deleteTsunamiAc,
  getTsunamis as getTsunamisAc,
  sortTsunamis as sortTsunamisAc,
  toggleTsunamiColumns as toggleTsunamiColumnsAc,
} from '../../../../../../redux/tsunamis/deposits/related-tsunamis/depositRelatedTsunamisActions';


import { withUser } from '../../../../../auth/withUser';
import { TsunamiDataGrid } from '../../events/data/TsunamiDataGrid';

class DepositRelatedTsunamiPageUnwrapped extends Component {
  componentDidMount() {
    document.title = 'NCEI Hazard Tsunami Deposit Reference';
    const {
      match: { params: { id } },
      clearData,
      getDeposit,
      getTsunamis,
      getPublications,
      getGeologicAges,
    } = this.props;
    clearData();
    getDeposit({ id });
    getTsunamis({ id });
    getPublications({ id });
    getGeologicAges({ id });
  }

  componentWillUnmount() {
    const { clearData } = this.props;
    clearData();
  }

  render() {
    const {
      fetched,
      deposit,
      tsunamis,
      authorities,
      sortTsunamis,
      toggleTsunamiColumns,
      deletingTsunami,
      deleteTsunami,
      getTsunamis,
      tsunamiSort,
      visibleTsunamiColumns,
    } = this.props;

    const dataManager = isDataManager(authorities);

    if (!fetched) {
      return (<Loading />);
    }

    const searchParams = `Deposit ID = ${deposit.get('id')}`;

    return (
      <div className="haz-results-container haz-page-container">

        <div className="haz-info-content">
          <div className="haz-info-content-section">
            <Card>
              <CardBody>
                <CardTitle tag="h2">Tsunami Deposit Reference</CardTitle>
                <SingleResultGrid data={deposit}>
                  <Column id="author" width={300}>Author</Column>
                  <Column id="year" width={100}>Year</Column>
                  <Column id="publication" width={200}>Publication</Column>
                  <Column id="event" width={200}>Event</Column>
                  <Column id="geologicAge" width={200}>Geologic Age</Column>
                  <Column id="ageDescription" width={200}>Age Description</Column>
                  <Column id="yearBegin" width={150}>Earliest Year</Column>
                  <Column id="yearEnd" width={150}>Latest Year</Column>
                  <Column id="latitude" width={150} cell={({ value }) => (<div>{parseAndShortenFloat(value)}</div>)}>Latitude</Column>
                  <Column id="longitude" width={150} cell={({ value }) => (<div>{parseAndShortenFloat(value)}</div>)}>Longitude</Column>
                  <Column id="locationName" width={200}>Location Name</Column>
                  <Column id="country" width={200}>Country</Column>
                  <Column id="bodyOfWater" width={150}>Body of Water</Column>
                  <Column id="description" width={200}>Narrative Description</Column>
                  <Column id="environment" width={200}>Setting During Event</Column>
                </SingleResultGrid>
              </CardBody>
            </Card>
          </div>
        </div>

        <div className="haz-info-content haz-data-grid-container">
          <div className="haz-info-content-section haz-data-grid-container">
            <Card>
              <CardBody>
                <CardTitle tag="h2">Associated Tsunami Events</CardTitle>
                <TsunamiDataGrid
                  tsunamiEvents={tsunamis}
                  dataManager={dataManager}
                  sortData={sortTsunamis}
                  sort={tsunamiSort}
                  visibleColumns={visibleTsunamiColumns}
                  toggleColumns={toggleTsunamiColumns}
                  searchParams={searchParams}
                  deleting={deletingTsunami}
                  deleteTsunami={deleteTsunami}
                  onDeleteCloseModal={getTsunamis}
                />
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

DepositRelatedTsunamiPageUnwrapped.propTypes = {
  fetched: PropTypes.bool.isRequired,
  deposit: ImmutablePropTypes.map.isRequired,
  tsunamis: ImmutablePropTypes.list.isRequired,
  deletingTsunami: PropTypes.bool.isRequired,
  tsunamiSort: ImmutablePropTypes.list.isRequired,
  visibleTsunamiColumns: ImmutablePropTypes.list.isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.number }) }).isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
  getDeposit: PropTypes.func.isRequired,
  getGeologicAges: PropTypes.func.isRequired,
  getPublications: PropTypes.func.isRequired,
  clearData: PropTypes.func.isRequired,
  deleteTsunami: PropTypes.func.isRequired,
  getTsunamis: PropTypes.func.isRequired,
  sortTsunamis: PropTypes.func.isRequired,
  toggleTsunamiColumns: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  fetched: [
    state.getIn(['depositRelatedTsunamisPage', 'fetchedDeposit']),
    state.getIn(['depositRelatedTsunamisPage', 'fetchedPublications']),
    state.getIn(['depositRelatedTsunamisPage', 'fetchedGeologicAges']),
    state.getIn(['depositRelatedTsunamisPage', 'fetchedTsunamis']),
  ].every(v => v),
  deposit: state.getIn(['depositRelatedTsunamisPage', 'deposit']),
  tsunamis: state.getIn(['depositRelatedTsunamisPage', 'tsunamis']),
  deletingTsunami: state.getIn(['depositRelatedTsunamisPage', 'deletingTsunami']),
  tsunamiSort: state.getIn(['depositRelatedTsunamisPage', 'tsunamiSort']),
  visibleTsunamiColumns: state.getIn(['depositRelatedTsunamisPage', 'visibleTsunamiColumns']),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getDeposit: getDepositAc,
  getGeologicAges: getGeologicAgesAc,
  getPublications: getPublicationsAc,
  clearData: clearDataAc,
  deleteTsunami: deleteTsunamiAc,
  getTsunamis: getTsunamisAc,
  sortTsunamis: sortTsunamisAc,
  toggleTsunamiColumns: toggleTsunamiColumnsAc,
}, dispatch);


export const DepositRelatedTsunamiPage = withUser(connect(mapStateToProps, mapDispatchToProps)(DepositRelatedTsunamiPageUnwrapped));
